/* eslint-disable max-statements-per-line */
/* eslint-disable max-len */
/* eslint-disable complexity */

export default {
    name       : 'PeriodicOperations',
    props : {
        newOperationState : {
            type     : Object,
            required : true
        },
        type : {
            type     : String,
            required : true
        }
    },
    /**
     * @override
     */
    data() {
        return {
            updatesCount: 0
        };
    },
    /**
     * @override
     */
    computed: {
        /**
         * @return {Object} minimal date to start
         */
        minStartDate() {
            let minamalDate = this.$moment();
            if (this.newOperationState.productType.type === 'F') {
                minamalDate = this.$moment().format('YYYY-MM-DD');
            }
            if (this.newOperationState.operationTypeSelected.key_name === 'SOLICITUD_APORTACION_PERIODICA') {
                const today = this.$moment();
                const todayDay = today.date();
                let monthsToAdd = 0;
                if (todayDay > 25) {
                    monthsToAdd = 1;
                }
                minamalDate = this.$moment().add(monthsToAdd, 'months');
            }
            return minamalDate;
        },
        /**
         * @return {Object} minimal date to start
         */
        minEndDate() {
            let monthsToAdd = 0;
            let start = this.$moment();
            if (this.newOperationState.operationObj.per_start_date) {
                start = this.$moment(this.newOperationState.operationObj.per_start_date);
            }
            if (this.newOperationState.operationObj.per_period) {
                switch (this.newOperationState.operationObj.per_period.key) {
                    case 'MENSUAL':
                        monthsToAdd = 1;
                        break;
                    case 'TRIMESTRAL':
                        monthsToAdd = 3;
                        break;
                    case 'SEMESTRAL':
                        monthsToAdd = 6;
                        break;
                    case 'ANUAL':
                        monthsToAdd = 12;
                        break;
                    default:
                        break;
                }
            }
            return start.add(monthsToAdd, 'months');
        },
        /**
         * @return {Object} periodicityIncreaseOptions
         */
        periodicityIncreaseOptions() {
            let options = [];
            if (this.newOperationState.productType.type === 'P') {
                options = [
                    {
                        key: 'ANUAL', name: 'Anual'
                    },
                    {
                        key: 'BIANUAL', name: 'Binual'
                    },
                    {
                        key: 'TRIANUAL', name: 'Trianual'
                    }
                ];
            } else {
                options = [
                    {
                        key: 'MENSUAL', name: 'Mensual'
                    },
                    {
                        key: 'TRIMESTRAL', name: 'Trimestral'
                    },
                    {
                        key: 'ANUAL', name: 'Anual'
                    }
                ];
            }
            return options;
        },
        /**
         * @return {Object} periodicityIncreaseOptions
         */
        periodicityOptions() {
            let options = [];
            if (this.newOperationState.productType.type === 'P') {
                options = [
                    {
                        key: 'MENSUAL', name: 'Mensual'
                    },
                    {
                        key: 'TRIMESTRAL', name: 'Trimestral'
                    },
                    {
                        key: 'SEMESTRAL', name: 'Semestral'
                    },
                    {
                        key: 'ANUAL', name: 'Anual'
                    }
                ];
            } else {
                options = [
                    {
                        key: 'MENSUAL', name: 'Mensual'
                    },
                    {
                        key: 'TRIMESTRAL', name: 'Trimestral'
                    },
                    {
                        key: 'ANUAL', name: 'Anual'
                    }
                ];
            }
            return options;
        },
        /**
         * @return {Object} revaluationOptions
         */
        revaluationOptions() {
            return [
                {
                    key: 'no-increase', name: 'Sin incremento'
                },
                {
                    key: 'LINEAL', name: 'Lineal'
                },
                {
                    key: 'ACUMULATIVO', name: 'Acumulativo'
                },
                {
                    key: 'PORCENTUAL', name: 'Porcentual'
                }
            ];
        }

    },
    methods: {
        /**
         *
         * @param {String} field name of field
         * @return {Boolean} isDisabledField
         */
        isDisabledField(field) {
            if (!this.newOperationState.operationObj.grossAmount)  {
                return true;
            }

            const noIncrease = this.newOperationState.operationObj.per_increase_type.key === 'no-increase';

            switch (field) {
                case 'INCREASE_VALUE':
                case 'INCREASE_PERIODICITY':
                    return noIncrease;
                default:
                    return false;
            }
        },

        /**
         * @param {String} val date of start
         */
        onSelectStartDate(val) {
            this.newOperationState.operationObj.per_start_date = val;
            if (val) {
                this.newOperationState.keyAddOperation++;
            }
        },
        /**
         * Seleccion de periodo
         */
        onSelectPerPediod() {
            this.newOperationState.operationObj.per_start_date = null;
            this.newOperationState.operationObj.per_end_date = null;
            this.newOperationState.operationObj.is_per_end_date_undefined = undefined;
            this.newOperationState.keyAddOperation++;
        },
        /**
         * Seteo de per_increase_period
         */
        onSelectPerIncreasePediod() {
            this.newOperationState.keyAddOperation++;
        },
        /**
         * @param {String} val per_increase type
         */
        onSelectRevaluationType(val) {
            if (val.key === 'no-increase') {
                this.newOperationState.operationObj.per_increase = null;
                this.newOperationState.operationObj.per_increase_period = null;
            }
            this.newOperationState.keyAddOperation++;
        },
        /**
         * @param {Boolean} isUndefined per_end_date value
         */
        handleEndDate(isUndefined) {
            if (isUndefined) {
                this.newOperationState.operationObj.per_end_date = undefined;
            } else {
                this.newOperationState.operationObj.per_end_date = null;
            }
            this.newOperationState.operationObj.is_per_end_date_undefined = isUndefined;
        },
        /**
         * Retrieve bank accounts data
         */
        getBankAccountsData() {
            this.$accountsService.getAccountBankAccounts(this.newOperationState.account.uuid, {}).then(res => {
                const fake = { iban_code: 'Nueva cuenta', is_fake: true };
                // this.newOperationState.account.bankAccounts = res.data.bank_accounts.filter(ba => ba.is_validated);
                this.newOperationState.account.bankAccounts = res.data.bank_accounts;
                this.newOperationState.account.bankAccounts.push(fake);
                this.newOperationState.bankAccount = null;
                this.updatesCount++;
            });
        },
        /**
         * Handle new bank account
         * @param {Object} selectedBankAccount selectedAccount
         */
        onNewAccount(selectedBankAccount) {
            this.newOperationState.keyAddOperation++;
            if (selectedBankAccount.is_fake) {
                this.newOperationState.bankAccount = null;
                const item = {
                    active: true,
                    name: this.newOperationState.account.id_object,
                    route: {
                        name: 'accounts_uuid',
                        params: {
                            uuid: this.newOperationState.account.uuid
                        },
                        force: true
                    }
                };
                localStorage.setItem(`tabs_account_${this.newOperationState.account.uuid}`, 4);
                this.setMenuTab(item);
            }
        }
    },
    /**
     * @override
     */
    beforeMount() {
        if (this.newOperationState.operationObj.per_end_date === null && this.newOperationState.isEdition) {
            this.newOperationState.operationObj.is_per_end_date_undefined = true;
            this.newOperationState.operationObj.per_end_date = undefined;
        }
    }
};
